import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';


const TemplatesSection = () => {
  const templates = [
    {
      id: "1",
      name: "WhatsApp Order Updates",
      description: "Keep customers in the loop with automated 'Shipped' and 'Out for Delivery' alerts.",
      category: "E-commerce",
      icon: "Truck",
      previewImage: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?auto=format&fit=crop&q=80",
      previewImageAlt: "Order delivery automation"
    },
    {
      id: "2",
      name: "Real Estate Lead Nurture",
      description: "Instant response to Zillow/Website inquiries asking 'When would you like to view the property?'",
      category: "Real Estate",
      icon: "Home",
      previewImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80",
      previewImageAlt: "Real estate automation"
    },
    {
      id: "3",
      name: "Appointment No-Show Killer",
      description: "Sends reminders 24h, 1h, and 10m before a call. Includes a 'Reschedule' button.",
      category: "Healthcare/Consulting",
      icon: "Calendar",
      previewImage: "https://images.unsplash.com/photo-1633526543814-9718c8922b7a?auto=format&fit=crop&q=80",
      previewImageAlt: "Calendar automation"
    }
  ];

  return (
    <section className="py-20 bg-muted/30 border-y border-border/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Pre-Built Automation Templates
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We don't start from scratch. We use proven frameworks that are generating revenue for our clients right now.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {templates.map((template) => (
            <div
              key={template.id}
              className="bg-card border border-border rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={template.previewImage}
                  alt={template.previewImageAlt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 bg-background/90 backdrop-blur text-foreground px-3 py-1 rounded-full text-xs font-bold border border-border">
                  {template.category}
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 text-primary">
                    <Icon name={template.icon} size={20} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-foreground leading-tight mb-1">
                      {template.name}
                    </h3>
                  </div>
                </div>

                <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
                  {template.description}
                </p>

                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  iconName="ArrowRight"
                  iconPosition="right"
                  className="group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary"
                >
                  See Workflow Diagram
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TemplatesSection;